import axios from 'axios'

// The UI strings for vue-i18n, built and cached by the API (ADR-0060).
// main.js awaits this before it mounts the app (ADR-0047).
export const loadMessages = async (endpoint) => {
  const response = await axios.get(`${endpoint}/v1/i18n/ui/`, {
    withCredentials: false,
  })
  return response.data
}
